import axios from "axios";

const getMenusApi = async () => {
  const res = await axios.get("v1/website/menus");
  return res.data;
};

export { getMenusApi };
